import { regions } from '../selectedTickers';

export function getRegions() {
    return regions;
}

export function getDefaultRegion() {
    for (const region of regions) {
        if (region.default) {
            return region;
        }
    }

    return false;
}

export function getRegionById(id) {
    for (let i = 0; i < regions.length; i++) {
        if (regions[i].id === id) {
            return regions[i];
        }
    }

    return false;
}

export function getMarkets(regionId) {
    const region = getRegionById(regionId);

    if (region) {
        return region.markets || [];
    }

    return false;
}

export function getMarketById(marketId) {
    for (let i = 0; i < regions.length; i++) {
        const markets = regions[i].markets.filter(m => m.id === marketId);

        if (markets.length === 1) {
            return markets[0];
        }
    }

    return false;
}

export function getDefaultMarket(regionId) {
    const region = getRegionById(regionId);

    if (region.defaultMarket) {
        return getMarketById(region.defaultMarket);
    }

    if (region.markets && region.markets.length) {
        return region.markets[0];
    }

    return false;
}

export function getLists(marketId) {
    const market = getMarketById(marketId);

    if (market) {
        return market.lists || [];
    }

    return false;
}

export function getListById(marketId, listId) {
    const lists = getLists(marketId);

    if (!lists || lists.length === 0) {
        return false;
    }

    const list = lists.filter(l => l.id === listId);

    if (list.length) {
        return list[0];
    }

    return false;
}

export function getDefaultList(marketId) {
    const market = getMarketById(marketId);

    if (market.defaultList) {
        return getListById(marketId, market.defaultList);
    }

    if (market.lists && market.lists.length) {
        return market.lists[0];
    }

    return false;
}

export function getDefaultListForRegion(regionId) {
    const market = getDefaultMarket(regionId);
    const list = getDefaultList(market.id);

    if (list) {
        return list;
    }

    return false;
}

export function getMarketSources(marketId) {
    const market = getMarketById(marketId);

    return market.sources || [
        'winners',
        'losers',
        'turnover',
        'largest_trades',
    ];
}

export function getRanking(sort) {
    if (!sort.column) {
        return 'LONG_NAME';
    }

    if (sort.direction && sort.direction === 'DESC') {
        return `-${sort.column}`;
    }

    return sort.column;
}

export function getAllMarkets() {
    const markets = [];

    regions.forEach(region => region.markets.forEach(market => markets.push(market)));

    return markets;
}

export function getSourceByFilters(regionId, marketId = null, listId = null) {
    const region = getRegionById(regionId);
    let market = getDefaultMarket(region.id);
    let list = getDefaultList(market.id);

    if (marketId && typeof marketId !== 'undefined') {
        market = getMarketById(marketId);
    }

    if (listId && typeof listId !== 'undefined') {
        list = getListById(marketId, listId);
    }

    return [market.feed, list.source].join('.');
}

export function getSourceByMarket(market) {
    const list = getDefaultList(market.id);

    return [market.feed, list.source].join('.');
}

export function sortsymbols(symbols, column, direction) {
    const directions = {
        ASC: { gt: 1, lt: -1, eq: 0 },
        DESC: { gt: -1, lt: 1, eq: 0 },
    };

    return symbols.sort((a, b) => {
        let dir = direction;
        let aColumn = a.values[column];
        let bColumn = b.values[column];

        // If the a or b values are undefined, we change it to an
        // unlikely low number in order for the sorting to work correctly
        if (typeof aColumn === 'undefined') {
            aColumn = -9999999999;
        }

        if (typeof bColumn === 'undefined') {
            bColumn = -9999999999;
        }

        // Fix the value if the LAST column is selected, since it may be
        // one of three columns.
        if (column === 'LAST') {
            aColumn = (a.values.LAST || a.values.LASTNZ || a.values.LASTNZ_DIV);
            bColumn = (b.values.LAST || b.values.LASTNZ || b.values.LASTNZ_DIV);
        }

        // Weird quirk where strings are interpreted opposite to
        // the number columns, so the direction needs to be reversed.
        if (column === 'LONG_NAME' || column === 'SECURITYNAME') {
            dir = dir === 'ASC' ? 'DESC' : 'ASC';
        }

        // Makes non-caseSensitive sorting when sorting on LONG_NAME
        // If LONG_NAME is missing, aColumn or bColumn is previously set to undefined (-99999999).
        // toString sets it to a sortable string value.
        if (column === 'LONG_NAME') {
            if (typeof aColumn === 'string') {
                aColumn = aColumn.toLowerCase();
            } else {
                aColumn = toString(aColumn);
            }

            if (typeof bColumn === 'string') {
                bColumn = bColumn.toLowerCase();
            } else {
                bColumn = toString(bColumn);
            }
        }

        if (aColumn < bColumn) {
            return directions[dir].lt;
        } else if (aColumn > bColumn) {
            return directions[dir].gt;
        }

        return directions[dir].eq;
    });
}



/** WEBPACK FOOTER **
 ** /src/shared/service/stocks.js
 **/